import { render } from "./MatchPercentage.vue?vue&type=template&id=42ff526a&scoped=true&ts=true"
import script from "./MatchPercentage.vue?vue&type=script&lang=ts"
export * from "./MatchPercentage.vue?vue&type=script&lang=ts"

import "./MatchPercentage.vue?vue&type=style&index=0&id=42ff526a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ff526a"]])

export default __exports__